riot.tag2('bbc-notifications', '<bbc-notifications-bell alert="{this.alert}" state="{this.state}"></bbc-notifications-bell> <bbc-notifications-drawer name="drawer" component-app="{this}" state="{this.state}" onboarding="{this.onboarding}" notifications="{this.notifications}" reached-end="{this.reachedEnd}" loading-more="{this.loadingMore}" error="{this.error}"></bbc-notifications-drawer>', '', '', function(opts) {
var _this = this;

var config = require('../config');
var notificationsAnalytics = require('../analytics');
var NotificationsModelClass = require('../models/NotificationsModel').NotificationsModel;

var userPreferencesModel = require('../models/UserPreferences');
var drawerName = 'notifications';

this.state = opts.mainApp.idcta.hasCookie() ? 'signed-in' : 'signed-out';
this.alert = false;
this.onboarding = false;
this.notifications = [];
this.reachedEnd = false;
this.loadingMore = false;
this.error = {};

this.isUserOnBoarded = function () {
    var preferencesData = userPreferencesModel.get();
    if (!preferencesData) {
        return null;
    }

    console.log('Preferences model', preferencesData);
    var userPreferences = preferencesData.preferences;

    return userPreferences !== null && typeof userPreferences.hasOnboarded !== 'undefined' ? userPreferences.hasOnboarded : false;
};

this.setOnboarding = function (setting) {
    console.log('Setting onboarding', setting);

    if (!setting) {
        _this.update({ alert: false });
        _this.initModel();
    }

    _this.update({ onboarding: setting });
};

this.drawerStateChangedCallback = function (newState) {
    console.log('Drawer is now', newState);
    _this.update({ alert: false });

    if (newState === 'hidden') {
        if (_this.notificationsModel) {
            var markedSeen = _this.notificationsModel.markAllAsSeen();
            _this.update({
                notifications: markedSeen
            });
        }
    } else {
        if (document.activeElement && document.activeElement.classList && document.activeElement.classList.contains('js-notification-link')) {
            document.querySelector('.notifications__settings--js').focus();
        }
    }

    userPreferencesModel.updateRead(true);

    // User is signed-in
    if (_this.state === 'signed-in') {
        if (typeof app !== 'undefined') {
            // return app.drawerStateChanged(newState);
            // TODO replace with an event for the main view to deal with

            return;
        }

        // Load the on-boarding upon drawer opened for the first time
        // (only if we are not in error state)
        if (!_this.isUserOnBoarded() && !_this.onboarding && !_this.errorState) {
            _this.setOnboarding(true);
        }
    } else {
        // User is signed-out
        if (newState === 'hidden') {
            // Analytics event (notificationsIcon close-pane)
            notificationsAnalytics.log('close-pane', 'notifications-icon');
        } else {
            // Analytics event (upsell when user is signed-out)
            notificationsAnalytics.log('upsell', 'notifications-icon');
        }
    }

    _this.trigger('drawerStateChanged', newState);
};

this.fetchNotifications = function (fetchNext) {
    if (fetchNext) {
        _this.update({ loadingMore: true });
    }

    var prevNotificationsLength = _this.notifications.length;

    return _this.notificationsModel.fetch(fetchNext).catch(function (err) {
        _this.setError('main', 'hub');
        throw err;
    }).then(function (response) {
        if (!response) {
            return;
        }

        var notifications = response.notifications;
        var reachedEnd = response.reachedEnd;

        console.log('Notifications', notifications.length, notifications, reachedEnd ? 'ENDED' : '...');

        _this.notifications = notifications;
        if (reachedEnd) {
            _this.reachedEnd = reachedEnd;
        }
        _this.loadingMore = false;

        var hasNew = false;
        notifications.forEach(function (i) {
            if (i.status === 'new') {
                hasNew = true;
            }
        });

        console.warn('Has new?', hasNew);
        if (hasNew && notifications.length > prevNotificationsLength) {
            _this.alert = true;
        }

        _this.update();
    });
};

this.setError = function (type, val) {
    console.error('Displaying error', type, val);
    _this.error[type] = val;
    _this.update();
};

this.resetNotifications = function () {
    _this.update({ notifications: [], reachedEnd: false });
    _this.notificationsModel.reset();
    _this.fetchNotifications();
};

this.initModel = function () {
    if (!_this.notificationsModel) {
        console.log('Instantiating model class');
        _this.notificationsModel = new NotificationsModelClass();
        console.log('Fetching notifications');
        _this.fetchNotifications();
        window.setInterval(_this.fetchNotifications, config.env.notificationsPollingInterval);
    }
};

this.setup = function () {
    // Fetch preferences
    if (_this.state === 'signed-in') {
        userPreferencesModel.fetch().catch(function (err) {
            _this.setError('main', 'hub');
            throw err;
        }).then(function () {
            if (!_this.isUserOnBoarded()) {
                console.log('Not onboarded, ring the bell');
                _this.update({ alert: true });
            } else {
                _this.initModel();
            }
        });
    }

    // Create drawer holder
    var drawerContent = document.createElement('div');
    drawerContent.className = 'orb-panel';
    drawerContent.appendChild(_this.drawer);

    // Move drawer into Orbit
    opts.orb.addDrawer(drawerName, document.querySelector('.js-notification-link'), drawerContent, _this.drawerStateChangedCallback);

    // Set notif icon. Needed for onboarding file.
    opts.mainApp.setNotificationIcon();
};

this.on('mount', this.setup);
this.on('updated', function () {
    console.log('Notifications component updated!', drawerName);
    opts.mainApp._updateWrapperMaxHeight();
});
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/components/bbc-notifications.tag
 ** module id = 18
 ** module chunks = 0
 **/